var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnPremierIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pn-premier-icon3_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 69 71",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pn-premier-icon3_svg__st2,.pn-premier-icon3_svg__st4{fill:none;stroke:#020303;stroke-width:2}.pn-premier-icon3_svg__st4{stroke:#d9d9d9}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon3_svg__Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon3_svg__Estate-Agents:-Featured-1",
    transform: "translate(-1102 -449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon3_svg__Group-35",
    transform: "translate(1103 449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Fill-1",
    d: "M34.7 5.3c16.1 21.2-7.8 45.1-29 29-16.1-21.2 7.8-45.1 29-29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7dce3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Fill-3",
    d: "M63.1 12.8H28.9c-1.8 0-3.2 1.4-3.2 3.2v21.4c0 1.8 1.4 3.2 3.2 3.2h34.2c1.8 0 3.2-1.4 3.2-3.2V16c0-1.8-1.4-3.2-3.2-3.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-5",
    className: "pn-premier-icon3_svg__st2",
    d: "M25.7 24.5V16c0-1.8 1.4-3.2 3.2-3.2h34.2c1.8 0 3.2 1.4 3.2 3.2v21.4c0 1.8-1.4 3.2-3.2 3.2H28.9c-1.8 0-3.2-1.4-3.2-3.2v-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-7",
    className: "pn-premier-icon3_svg__st2",
    d: "M63.1 16L49.8 27.4c-1 .9-2.4 1.4-3.8 1.4s-2.7-.5-3.8-1.4L28.9 16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-9",
    className: "pn-premier-icon3_svg__st2",
    d: "M51.3 25.6l11.8 11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-11",
    className: "pn-premier-icon3_svg__st2",
    d: "M40.6 25.6L35.3 31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Fill-13",
    d: "M37.4 34.2H3.2c-1.8 0-3.2 1.4-3.2 3.2v21.4C0 60.5 1.4 62 3.2 62h34.2c1.8 0 3.2-1.4 3.2-3.2V37.4c0-1.8-1.4-3.2-3.2-3.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ea4a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-15",
    className: "pn-premier-icon3_svg__st2",
    d: "M40.6 48.1V37.4c0-1.8-1.4-3.2-3.2-3.2H3.2c-1.8 0-3.2 1.4-3.2 3.2v21.4C0 60.5 1.4 62 3.2 62h34.2c1.8 0 3.2-1.4 3.2-3.2v-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-17",
    className: "pn-premier-icon3_svg__st2",
    d: "M36.4 37.4L24.1 48.8c-1 .9-2.4 1.4-3.8 1.4s-2.7-.5-3.8-1.4L3.2 37.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-19",
    className: "pn-premier-icon3_svg__st2",
    d: "M25.7 47l11.7 11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-21",
    className: "pn-premier-icon3_svg__st2",
    d: "M14.4 47.5L3.2 58.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-23",
    className: "pn-premier-icon3_svg__st2",
    d: "M29.9 24.5H17.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-25",
    className: "pn-premier-icon3_svg__st2",
    d: "M21.4 12.8H9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-27",
    className: "pn-premier-icon3_svg__st2",
    d: "M36.4 49.1h12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-29",
    className: "pn-premier-icon3_svg__st2",
    d: "M44.9 62h11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-31",
    className: "pn-premier-icon3_svg__st4",
    d: "M20.3 69.5h30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon3_svg__Stroke-33",
    className: "pn-premier-icon3_svg__st4",
    d: "M49.2 5.3H19.3"
  }))))));
}
export default SvgPnPremierIcon3;